import routeConfig from 'edge/fnol/cp/config/RouteConfig';
import SelectionSummary from 'edge/fnol/cp/components/SelectionSummary';
import PropertyDetails from 'edge/fnol/cp/directives/PropertyDetails/PropertyDetails';
import 'edge/fnol/common/app';

export default angular.module('edge.fnol.cp.app', ['edge.fnol.common.app']).config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
    var states = routeConfig(RootStateConfig);
    for (var stateName in states) {
        if (states.hasOwnProperty(stateName)) {
            $stateProvider.state(stateName, states[stateName]);
        }
    }
}]).directive('gwPropertyDetails', PropertyDetails).constant('propertiesPageSize', 25).component('gwFnolCpSelectionSummary', SelectionSummary);